/**
 * Created by tofaelraju on 10/15/17.
 */

import React from 'react';
import ReactTable from 'react-table';

const tableStyles = {
  backgroundColor:'#fff',
  textAlign: 'Center'
};

const defaultFilterMethod = (filter, row) => String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())

const List=({reactTableProps, onResolve, noFilter})=>(
  <div className="table-wrap">
    <ReactTable
      style={tableStyles}
      filterable={!noFilter}
      defaultFilterMethod={defaultFilterMethod}
      {...reactTableProps}
      getTrProps={(state, rowInfo, column) => {
        let style = {
          cursor: 'pointer'
        };

        if (rowInfo && rowInfo.original.test) {
          style.background = '#FFFFE0';
        }
        return {
          style
        }
      }}
    />
  </div>
);
export default List;


// WEBPACK FOOTER //
// ./src/screens/list/list.js